import type { FaireProductEntity } from "../../entity_types/product";

export const p_5tf3mnhbng: FaireProductEntity = {
  token: "p_5tf3mnhbng",
  type: "product",
  name: "Chain Tassel Ring 18K Gold Two Tone Steel Design S5P061",
  brandToken: "b_vzcwf2s2c8",
  brandName: "alberalkirk",
  imageUrl:
    "https://cdn.faire.com/fastly/8b4e156f11abcb726b8cf94e3a5c2e097dce8ba53c12c2560611ceb92d0ed6a7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b71e518d155d7a11a1031ed467205bf932f287bc616a2b073524a0db1bfb7b3f.jpeg",
    "https://cdn.faire.com/fastly/02826dd707f5509e163e533b19e9f9a5dca1973a71f0f4b5f7b9a95bf5561b32.jpeg",
    "https://cdn.faire.com/fastly/9e5540eee3d096735c0b86f0c65d4900a17ad7c060f94881d54113b8a093da93.jpeg",
    "https://cdn.faire.com/fastly/0c219a3fe911b8b0901973abefd32fe9e66d022cdd8f850976cba1b6be88083b.jpeg",
    "https://cdn.faire.com/fastly/3a891e313444718419059aa60c002b9a8334a52388fedcd4ee481cacc0c4c51b.jpeg",
  ],
  priceDollars: 6.91,
  description:
    "Material:\n * Stainless Steel\n\n Weight:\n * 7.2g\n\n Feature:\n * Liquid Tassel Chain Movement\n * Rhodium & 18K Gold Plated\n * Interlocking Metallic Weave\n * Light Luxury Silhouette\n * Contrast Satin-Mirror Finishes\n\n Note:\n * Care: Use jewelry polishing cloth\n * Two-tone requires separate cleaning\n * Non-tarnish oxidation barrier ",
  tags: [],
  msrpDollars: 13.83,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:48:45.133Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
